<template>

	<div class="ph_consent">

		<div class="container">
		  <div class="row partner-title">
		    <div class="col">
					<img src="/logos/logo-biogaran.png" class="img-fluid" width="80" height="80" alt="">
		    </div>
		    <div class="col">
			    <div class="line">&nbsp;</div>
					<div class="button">
						<button type="button" class="btn text-ok btn-icon rounded-round">
							<i class="icon-link"></i>
						</button>
					</div>
		    </div>
		    <div class="col">
					<img src="/logos/logo-ospharm.png" class="img-fluid" width="80" height="80" alt="">
		    </div>
		  </div>
		  <div class="row" style="text-align: center; margin-top: 20px;">
		    <div class="col">
					<h1>Autoriser Biogaran à accéder à vos données</h1>
				</div>
		  </div>
		</div>

	  <div class="card">
			<div class="media">
				<div class="mr-3">
					<button type="button" class="btn bg-primary text-white btn-icon rounded-round">
						<i class="icon-user"></i>
					</button>
				</div>

				<div class="media-body">
					<h6 class="media-title font-weight-semibold text-primary"><a href="#" class="font-size-lg text-primary-400">Données de compte</a></h6>
					Cette demande concerne le code CIP de votre pharmacie et sa position géographique (GPS).
				</div>
			</div>

			<div class="media">
				<div class="mr-3">
					<button type="button" class="btn bg-success text-white btn-icon rounded-round">
						<i class="icon-cart"></i>
					</button>
				</div>

				<div class="media-body">
					<h6 class="media-title font-weight-semibold"><a href="#" class="font-size-lg text-success-400">Prix de vente de certains produits</a></h6>
					Cette demande concerne le prix de vente des médicaments <strong>Biogaran Conseil</strong> et leur <strong>médicaments de référence</strong>.
				</div>
			</div>

			<div class="media" style="border-top: 1px solid #ddd">
				<div class="container">
					<div class="row">
						<div class="col">
							<button v-on:click="authorize" type="button" class="btn btn-primary" style="width: 100%; margin: 10px 0px;">Signer l'autorisation d'accès</button>
						</div>
					</div>
					<div class="row">
						<div class="col" style="text-align: center;">
							Après autorisation vous allez être redirigé vers <br/>
							<strong>https://www.biogaran.pro</strong>
						</div>
					</div>
				</div>
			</div>

	  </div>

		<div class="card" style="background: transparent;">
			<div class="container">
				<div class="row">
					<div class="col" style="padding: 3px;">
						<h6 class="mb-0">
							<i class="icon-headset mr-1"></i>
							<div>
								<span class="font-weight-semibold">Contacter</span> le support Biogaran Pro
							</div>
						</h6>
					</div>
					<div class="col" style="padding: 3px;">
						<h6 class="mb-0">
							<i class="icon-safe mr-1"></i>
							<div>
								<span class="font-weight-semibold">Echanges sécurisés</span> et cryptés.
							</div>
						</h6>
					</div>
					<div class="col" style="padding: 3px;">
						<h6 class="mb-0">
							<i class="icon-users4 mr-1"></i>
							<div>
								<span class="font-weight-semibold">8100 pharmaciens</span> coopérateurs
							</div>
						</h6>
					</div>
				</div>
			</div>
		</div>

		<div class="container">
			<div class="row">
				<div class="col" style="padding: 3px; text-align: center;">
					<a href="/">Plus d'informations sur Ospharm</a> -
					<router-link to="/register">Créer un compte</router-link>
				</div>
			</div>
		</div>

	</div>

</template>


<script>

export default {
 name: 'home',
 data() {
	 return {
		 name: "test"
	 }
 },
 components: {},
 mounted: function() {

 },
 methods: {
	 authorize: function() {
	 	window.location.href = process.env.VUE_APP_URL_BIOGARAN;		 
	 }
 }
}

</script>

<style type="text/css">

	@import url('https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900');

	body {
	  padding: 0px;
    background-color: rgb(245, 245, 245);
	  font-family: sans-serif;
	}
	.h1, .h2, .h3, .h4, .h5, .h6, h1, h2, h3, h4, h5, h6 {
	  letter-spacing: 0px;
	}
	.ph_consent {
	  margin: auto;
		max-width: 700px;
		width: 80%;
	}
	@media (max-width: 768px) {
		.ph_consent {
  	  width: 100%;
		}
	}
	.ph_consent .card {
	  width: 100%;
		background: #FFF;
		padding: 20px 15px;
	}
	.ph_consent h1 {
		font-weight: 300;
		font-size: 24px;
	}
	.ph_consent h6 {
	  position: relative;
	  font-size: 12px;
	  color: #586069 !important;
	}
	.ph_consent h6 i {
	  position: absolute;
	  top: 2px;
	}
	.ph_consent h6 div {
	  margin-left: 25px;
	}
	.ph_consent .font-size-lg {
	  font-size: .975rem;
	}
	.partner-title {
		position: relative;
	}
	.text-ok {
	  background: #95c21e;
	  color: #006841;
	}
	.partner-title .col:nth-child(2) {
		padding: 0px;
		text-align: center;
	}

	.partner-title .col:nth-child(2) .line {
		position: absolute;
		z-index: 1;
		height: 1px;
		width: 100%;
		top: 55px;
		border-bottom: 1px dashed grey;
	}

	.partner-title .col:nth-child(2) .button {
		position: absolute;
		z-index: 2;
		left: 0px;
		right: 0px;
		margin: 33px auto;
		width: 50px;
		height: 50px;
		text-align: center;
		background: #f5f5f5;
	}
	.partner-title .col:nth-child(2) .button button {
		margin: 5px auto 0px !important;
	}
	.partner-title .col:nth-child(1),
	.partner-title .col:nth-child(3) {
	  padding: 5px;
	  margin-top: 8px;
	  background: #FFF;
		text-align: left;
	  box-shadow: 0 1px 2px rgba(0,0,0,.05);
	  border: 1px solid rgba(0,0,0,.125);
	  border-radius: .1875rem;
	}
	.partner-title .col:nth-child(1) img,
	.partner-title .col:nth-child(3) img {
	  margin-top: 0px;
	  height: auto;
	  width: 100%;
	}

</style>
